import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  POLITICS = 'Politics',
  ELECTIONS = 'Elections',
  POLICY = 'Policy',
  NATIONAL_SECURITY = 'National Security',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['politics'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['politics/elections'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['politics/policy'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['politics/national-security'] } }
    ]
  }
};

const ELECTIONS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['politics/elections'] } }]
  }
};

const POLICY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['politics/policy'] } }]
  }
};

const NATIONAL_SECURITY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['politics/national-security'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['politics', 'politics/elections', 'politics/policy', 'politics/national-security']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'politics' } }, { prefix: { key: 'DJEThing', value: 'politics/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, ELECTIONS, POLICY, NATIONAL_SECURITY, RELATED_OPINION, VIDEO };
